import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { MemberType } from 'api/models';
import { ProjectPlaceholderResolve } from 'api/notifications/meta';
import { Avatar } from 'components/atoms/avatar';
import { PlaceholderAvatar } from 'components/molecules/placeholder-avatar';
import { Strong } from '../basics';
import { Causer } from './causer';

export const ProjectPlaceholderResolveView: FC<{
  meta: ProjectPlaceholderResolve;
}> = ({ meta: { by, company, team } }) => {
  return (
    <FormattedMessage
      id="notifications.messages.placeholder_resolve_to_company"
      values={{
        causer: <Causer user={by} />,
        placeholder: (
          <>
            <PlaceholderAvatar
              size="small"
              isCustomerRole={team.teamType === MemberType.External}
              name={team.teamName}
            />
            <Strong>{team.teamName}</Strong>
          </>
        ),
        company: (
          <>
            <Avatar
              size="small"
              name={company.companyName}
              src={company.companyLogoUrl}
            />
            <Strong>{company.companyName}</Strong>
          </>
        ),
      }}
    />
  );
};
